import React, { Component } from 'react';
import SwitchComponent from './SwitchComponent';
import { Typography } from '@material-ui/core';
import * as ValidationUtils from '../../utils/ValidationUtils';

export default class OfertaCuentaVistaComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seleccionado: true,
    };
  }

  onSelectionChange = (value) => {
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(value);
    }
  };

  render() {
    let datosLinea;
    if (this.props.producto.asociarLineaCredito) {
      datosLinea = <Typography>Cupo Línea de Crédito $ {ValidationUtils.formatMontoWithZero(this.props.producto.totalLinea)}</Typography>;
    }
    return (
      <div className="ofertaTarjetas ">
        <div className="textosTarjetas">
          <img className="tarjetas" src={require('../../images/debit.jpg')} alt="pfd" />
          <div>
            <Typography className="seleccionado">{this.props.producto.nombreProducto}</Typography>
            {datosLinea}
          </div>
        </div>

        <SwitchComponent checked={this.props.producto.selected} onChange={this.onSelectionChange} />
      </div>
    );
  }
}
